var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBucket = function SvgBucket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.116 12.759a.368.368 0 0 0-.254.24 3.985 3.985 0 0 1-.05-.018c-.036.154.05.326.26.394 1.103.357 2.894.588 4.922.588 2.028 0 3.824-.232 4.928-.59.208-.067.294-.237.26-.39a2.837 2.837 0 0 1-.05.018c-.028-.104-.113-.198-.255-.244-1.093-.357-2.868-.589-4.877-.589-2.01 0-3.79.233-4.884.59Zm11-.563C26.052 11.423 23.339 10.8 20 10.8c-3.338 0-6.051.623-6.117 1.396h-.01a19.241 19.241 0 0 0-1.473 5.868 26.342 26.342 0 0 0 15.2 0 19.247 19.247 0 0 0-1.472-5.868h-.011ZM20 29.296c3.385 0 5.516-.863 6.128-1.822a19.148 19.148 0 0 0 1.346-4.793 26.344 26.344 0 0 1-14.947 0 19.14 19.14 0 0 0 1.346 4.793c.351.84 2.743 1.822 6.127 1.822Z",
    fill: "#fff"
  })));
};
export default SvgBucket;